import apiFetch from '../../apiFetch'

export default function (stockDossierId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/confirmDateStock/crane/${stockDossierId}`, method: 'PUT', token: token, lastAccessDate })
}
